import { Controller } from "@hotwired/stimulus"

// Auto-saves a form after a debounced delay when inputs change.
// Usage: data-controller="auto-save" data-auto-save-delay-value="800"
// On inputs: data-action="input->auto-save#save" or "change->auto-save#save"
export default class extends Controller {
  static values = { delay: { type: Number, default: 800 } }

  save() {
    clearTimeout(this._timeout)
    this._timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, this.delayValue)
  }

  disconnect() {
    clearTimeout(this._timeout)
  }
}
